import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "@music-app/sync-supabase";

export function AuthCallbackPage() {
  const loading = useAuthStore((s) => s.loading);
  const navigate = useNavigate();

  // Wait for the auth store to finish initialising (which exchanges the PKCE
  // code via detectSessionInUrl), then go to Settings where the user can see
  // they're signed in.
  useEffect(() => {
    if (!loading) {
      navigate("/settings", { replace: true });
    }
  }, [loading, navigate]);

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <p className="text-inkSoft font-mono text-sm">Signing in…</p>
    </div>
  );
}
